import React from 'react';
import useModalStore from '../../stores/modal';
import useTokenStore from '../../stores/tokens';
import { compatApi } from '../../utils/Intercepter';
import toastConfig from '../../const/toastConfig';
import { toast } from 'react-toastify';

const OrganizationSelectModal = () => {
    const { closeOrgSelectModal } = useModalStore();
    const { user , setUser, setAuthenticated } = useTokenStore();
    const orgUserList = user?.orgUserList || [];

    const handleDefaultOrgSelect = async (orgCode) => {
        const selectedOrg = user.orgUserList.find(org => org.organizationCode === orgCode);
        if (selectedOrg) {
            const response = await compatApi.post(`/org/setting/defaultOrg`, {
                userEmail: user.userEmail,
                organizationCode: selectedOrg.organizationCode,
            });
            const { status, data, ok } = response;
            console.log('기본 조직 설정 요청 : ', response);
            console.log('기본 조직 설정 요청 응답 : ', status, data, ok);
            if (ok) {
                const updatedOrgList = user.orgUserList.map(org => {
                    if (org.organizationCode === selectedOrg.organizationCode) {
                        return { ...org, default: true };
                    } else {
                        return { ...org, default: false };
                    }
                });
                localStorage.setItem('currentOrganizationCode', selectedOrg.organizationCode);
                localStorage.setItem('currentOrganizationName', selectedOrg.organizationName);
                setUser({
                    currentOrganizationCode: selectedOrg.organizationCode,
                    currentOrganizationName: selectedOrg.organizationName,
                    currentRole: selectedOrg.userRole,
                    orgUserList: updatedOrgList,
                    currentOrganizationApproved: selectedOrg.isApproved ?? selectedOrg.approved
                });
                setAuthenticated(true);
                setTimeout(() => {
                    window.location.href = '/main';
                }, 500);
                
                toast.success('기본 조직이 설정되었습니다.', toastConfig);
                
            } else {
                if(status === 400) {
                    toast.error('이미 기본 조직으로 설정되어 있습니다.', toastConfig);
                }else{
                    toast.error('기본 조직 설정에 실패했습니다.', toastConfig);
                }
                return;
            }
            closeOrgSelectModal();
        } else {
            alert('선택된 조직 정보를 찾을 수 없습니다.');
        }
    }
    return (
        <div className="modal show fade d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">조직 선택</h5>
                        <button type="button" className="btn-close" onClick={()=>{closeOrgSelectModal();}}></button>
                    </div>
                    <div className="modal-body">
                        <p>로그인할 조직을 선택하세요:</p>
                        <ul className="list-group">
                            {orgUserList.map((org) => (
                                <li key={org.organizationCode} className="list-group-item d-flex justify-content-between align-items-center">
                                    {org.organizationName}
                                    <button className="btn btn-primary btn-sm" onClick={() => handleDefaultOrgSelect(org.organizationCode)}>
                                        선택
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={()=>{closeOrgSelectModal(); }}>닫기</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrganizationSelectModal;
